/**
 * Viser knapp for å skjule/vise ytterligere formateringsvalg
 */

// Register the plugin in the editor.
CKEDITOR.plugins.add('toggleformateringsknapper', {
    lang: 'nb,en',
    init: function (editor) {
        editor.ui.addButton('ToggleFormateringsknapperKnapp',
            {
                label: editor.lang.toggleformateringsknapper.label,
                command: 'ToggleFormateringsknapperKommando', //forventer at denne kommandoen er registrert av ckeditor initialiseringskode - se lederplan-klient/src/scripts/felles/direktiver/ckeditor.ts
                icon: CKEDITOR.plugins.getPath('toggleformateringsknapper') + 'mer.svg'
            });

       /* eksempel på registrering av kommando:
       editor.addCommand('ToggleFormateringsknapperKommando', {
            exec: () => {
                //gjør noe
            }
        });
        */
    }

});

CKEDITOR.plugins.setLang( 'toggleformateringsknapper', 'nb', {
    label: 'Flere valg'
});
CKEDITOR.plugins.setLang( 'toggleformateringsknapper', 'en', {
    label: 'More choices'
});